angular.module('mymessages', [
    //third party
    'angularLocalStorage',
    'gettext',
    'headroom',
    'lodash',
    'ngAnimate',
    'ngTouch',
    'restangular',
    'toaster',
    'ui.bootstrap',
    'ui.router',
    'apEasyScroller',

    'app',
    'mychart',

    'aprima-core',
    'aprima-bridge',
    'aprima-config',
    'aprima-legacy-common',
    'aprima-provider-api',
    'aprima-patient-api'

]);